import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import JoinNow from "../lobby/joinNow";
import PlayersCard from "./components/playersCard";
import CardsView from "./components/cardsView";
import CardsViewResult from "./components/CardViewResult";
import MultipleCardView from "./components/mutipleCardView";
import RoundOverScreen from "./components/roundOverScreen";
import GameOverScreen from "./components/gameOverScreen";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import { withSocket } from "../../socket/context";
import * as loaderAction from "../../redux/loader/action";
import hpwTo from "../../assets/images/OCH/howtoplayBG.png"
import hpwToClose from "../../assets/images/OCH/howtoplayCLOSE.png"
const OCHGame = (props) => {
	const roomData = _.get(props, "gameReducer.roomObj");
	const currentCard = _.get(roomData, "game_state.current_card");
	const currentRound = _.get(roomData, "game_state.current_round");
	const drawDeck = _.get(roomData, "game_state.draw_deck");
	const passCounter = _.get(roomData, "game_state.pass_counter");
	const status = _.get(roomData, "game_state.status");
	const param = _.get(props, "paramsReducer.gameObj.screens.och");
	const sounds = _.get(props, "paramsReducer.gameObj.sounds");
	const prevCurrentCard = useRef();
	const prevPassCounter = useRef();
	const prevDrawDeck = useRef();
	const defaultTrack = _.get(
		props,
		"paramsReducer.gameObj.sounds.default_sound"
	);
	const[howtoplay, setHowToPlay]=useState(false)
	//plays sound at the begning of each round
	useEffect(() => {
		playAudio(defaultTrack);
	}, [currentRound]);

	/**
	 * plays sound if user either plays a card or draws a card from deck
	 */
	useEffect(() => {
		//to avoid sound on initial render
		if (prevCurrentCard.current == undefined || currentCard == undefined) {
			prevCurrentCard.current = currentCard;
			prevDrawDeck.current = drawDeck;
		} else if (
			JSON.stringify(prevCurrentCard.current) != JSON.stringify(currentCard)
		) {
			if (currentCard.number == 8) {
				playAudio(_.get(sounds, "play_eight"));
			} else if (prevCurrentCard.current.number != 8 && prevCurrentCard.current.suit != currentCard.suit) {
				switch (currentCard.suit) {
					case "spades":
						playAudio(_.get(sounds, "switch_suit_spades"));
						break;
					case "diamonds":
						playAudio(_.get(sounds, "switch_suit_diamonds"));
						break;
					case "hearts":
						playAudio(_.get(sounds, "switch_suit_hearts"));
						break;
					case "clubs":
						playAudio(_.get(sounds, "switch_suit_clubs"));
						break;
				}
			} else {
				playAudio(_.get(sounds, "play_card"));
			}
		} else if (prevDrawDeck.current.length > drawDeck.length) {
			playAudio(_.get(sounds, "draw_card"));
		}
		else if (prevDrawDeck.current.length == 0 && prevDrawDeck.current.length < drawDeck.length) {
			playAudio(_.get(sounds, "shuffle_deck"));
		}
		prevCurrentCard.current = currentCard;
		prevDrawDeck.current = drawDeck;
	}, [currentCard, drawDeck]);

	/**
	 * plays sound when when a user passes a card
	 */
	useEffect(() => {
		//to avoid sound on initial render
		if (
			prevPassCounter.current !== undefined &&
			prevPassCounter.current !== passCounter
		) {
			playAudio(_.get(sounds, "passing"));
		}
		prevPassCounter.current = passCounter;
	}, [passCounter]);


	const playAudio = (url) => {
		var audio = document.createElement("audio");
		audio.src = url;
		audio.style.display = "none"; //added to fix ios issue
		audio.autoplay = true; //avoid the user has not interacted with your page issue
		audio.onended = function () {
			audio.remove(); //remove after playing to clean the Dom
		};
		document.body.appendChild(audio);
	};
	return (
		<>
		<div className="p-2 OCH-game-wrapper">
			{status !== "Over" && (
				<button className="play-tips" onClick={()=> setHowToPlay(!howtoplay)} hidden={true}>
					How to Play
				</button>
			)}
			<div className="och-width">
				{status && (status === "Playing" || status === "PrePlay") && (
					<div className="playing-cards-wrapper">
						<div className="playing-cards-col">
							<PlayersCard />
							{/* <PlayersCard /> */}
						</div>
						<div className="playing-cards-col">
							{roomData?.game_state?.crazy_suit !== undefined ? (
								<CardsViewResult roomData={roomData} />
							) : (
									<CardsView status={status} param={param} roomData={roomData} />
								)}
							<div className="multiple-cards-view-wrapper">
								<MultipleCardView param={param} roomData={roomData} />
							</div>
						</div>
						<div className="playing-cards-col right">
							{/* <PlayersCard />
          <PlayersCard /> */}
						</div>
					</div>
				)}
				{status && status === "ResultRound" && (
					<RoundOverScreen param={param} roomData={roomData} />
				)}
				{status && status === "Over" && (
					<GameOverScreen param={param} roomData={roomData} />
				)}
			</div>
		</div>
		{howtoplay &&
		<>
		<div className="back_drop_howtoplay">
		<div className='howtoplay_main' style={{backgroundImage:`url(${hpwTo})`}}>
			<div className='close_btn'>
				<button onClick={()=> setHowToPlay(false)} className="close-btn"><img src={hpwToClose} /></button>
			</div>
			<div className="title">
				<h3>HOW TO PLAY</h3>
			</div>
			<div className="containt">
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Blandit pretium semper sit cursus proin amet morbi mi dapibus. Mauris nulla in ultricies in. Maecenas eu, purus, molestie tortor. Velit enim, consequat, semper justo sit imperdiet tincidunt risus enim. Eu, risus est pretium non tortor nibh orci morbi egestas.</p>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Blandit pretium semper sit cursus proin amet morbi mi dapibus. Mauris nulla in ultricies in. Maecenas eu, purus, molestie tortor. Velit enim, consequat, semper justo sit imperdiet tincidunt risus enim. Eu, risus est pretium non tortor nibh orci morbi egestas.</p>
				<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Blandit pretium semper sit cursus proin amet morbi mi dapibus. Mauris nulla in ultricies in. Maecenas eu, purus, molestie tortor. Velit enim, consequat, semper justo sit imperdiet tincidunt risus enim. Eu, risus est pretium non tortor nibh orci morbi egestas.</p>
			</div>
		</div>
		</div>
		</>}
		</>
	);
};
const mapStateToProps = (state) => ({
	gameReducer: state.gameReducer,
	loaderDetails: state.loaderDetails,
	paramsReducer: state.paramsReducer,
});
const mapDispatchToProps = (dispatch) => {
	return {
		setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
	};
};
export default compose(
	withSocket,
	connect(mapStateToProps, mapDispatchToProps)
)(OCHGame);
// export default OCHGame;
